import Cookie from 'js-cookie'

const Removecookie = (cookiename)=>{
    Cookie.remove(cookiename)
}

export default Removecookie;